<template>
    <div class="form-group" v-if="charges.length > 0" v-loading="isBusy">
        <label>Stripe Transactions</label><br>
        <table class="table table-border" style="width:100%;margin:10px 0">
            <thead>
            <tr>
                <th>Trans ID</th>
                <th>Date</th>
                <th>Amount</th>
                <th>Customer</th>
                <th>Email</th>
                <th>Order</th>
                <th>Type</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="ch in charges">
                <td>{{ ch.stripe_charge_id }}</td>
                <td>{{ ch.created_at }}</td>
                <td>{{ ch.amount_captured }}</td>
                <td>{{ ch.stripe_name }}</td>
                <td>{{ ch.stripe_email }}</td>
                <td>{{ ch.description }}</td>
                <td>{{ ch.type }}</td>
                <td>
                    <btn css-class="btn btn-xs btn-text" :click="() => unlinkPayment(ch.id)">Unlink</btn>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        charges: { type: Array, required: true },
    },
    data() {
        return {
            isBusy: false,
        };
    },
    methods: {
        unlinkPayment(chargeId) {
            this.isBusy = true;
            return axios.get(url(`ajax/payments/unlink-stripe-transaction/${chargeId}`))
                        .then(response => {
                            this.$emit('unlinked', _.filter(this.charges, function (ch) { return ch.id !== chargeId; }));
                        })
                        .finally(() => {
                            this.isBusy = false;
                        });
        },
    },
};
</script>
